import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';

import { ContextMenuComponent } from './context-menu.component';
import { ContextMenuAttachDirective } from './context-menu.attach.directive';
import { ContextMenuItemDirective } from './context-menu.item.directive';

@NgModule({
  imports: [CommonModule, BrowserModule, MaterialModule], 
  declarations: [ContextMenuComponent, ContextMenuAttachDirective, ContextMenuItemDirective ],
  exports: [ContextMenuComponent, ContextMenuAttachDirective, ContextMenuItemDirective]
})
export class ContextMenuModule { }
